import { Stack, Typography } from "@mui/material";
import { Link } from "react-router";
import type { DocumentViews } from "../../../../api/types/documentActivityTypes";
import useClientContext from "../../../../context/useClientContext";
import { pageRoutes } from "../../../../routes";

interface Props {
  row: DocumentViews;
}

const DocumentViewsGridUserCell = ({ row }: Props) => {
  const { clientCode } = useClientContext();

  const contactId = row.userInfo.contactId;
  const canNavigateToContact = Boolean(contactId);

  return (
    <Stack
      component={canNavigateToContact ? Link : "div"}
      target="_blank"
      rel="noopener noreferrer"
      to={
        canNavigateToContact
          ? `/${clientCode}/${pageRoutes.investorRelations}/${pageRoutes.contacts}/${contactId}/main`
          : undefined
      }
      spacing={0.5}
      sx={[
        { width: "100%" },
        (t) =>
          canNavigateToContact
            ? { textDecoration: "none", color: "unset", ":hover": { color: t.palette.primary.main, cursor: "pointer" } }
            : {},
      ]}
    >
      <Typography variant="subtitle2" noWrap>
        {row.userInfo.userName}
      </Typography>
      <Typography variant="caption" noWrap color="textSecondary">
        {row.userInfo.userEmail}
      </Typography>
    </Stack>
  );
};

export default DocumentViewsGridUserCell;
